import React from 'react'

import { Typography } from '@barracuda-internal/bds-core'
import { Box, Button, useTokens, Alert } from '@barracuda-internal/bds-core-v2'

export interface ActionBaseProps {
  onClick?: () => void
  buttonLabel: string
  buttonBdsType: 'interactiveNeutral' | 'interactiveEmphasis'
  error: boolean
  errorContent: string
  loading: boolean
  icon: JSX.Element | undefined
  children: React.ReactNode
}

const ActionBase: React.FC<ActionBaseProps> = ({
  onClick,
  buttonLabel,
  buttonBdsType,
  error,
  errorContent,
  loading,
  icon,
  children
}) => {
  const tokens = useTokens()

  return (
    <Box
      sx={{
        radius: tokens.aliasesBorderRadiusDefault,
        padding: tokens.aliasesSpaceContainerSpacious,
        gap: tokens.aliasesSpaceContainerSpacious,
        backgroundColor: tokens.aliasesColorBgStaticComponentSubtle,
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '680px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: 'auto',
          gap: '0px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {!!icon && <Box>{icon}</Box>}
      </Box>
      {error && (
        <Alert bdsType="neutralError" bdsBoxShadowType="inline">
          <Typography variant="body1" align="left">
            {errorContent}
          </Typography>
        </Alert>
      )}
      <Box sx={{ marginBottom: tokens.aliasesSpaceContainerSpacious }}>{children}</Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={onClick} isLoading={loading} bdsType={buttonBdsType}>
          {buttonLabel}
        </Button>
      </Box>
    </Box>
  )
}

export default ActionBase
